import { usePunishmentLogic } from '@/hooks/usePunishmentLogic';
import { PunishmentForm } from '@/components/company/punishment/PunishmentForm';
import { PunishmentFilters } from '@/components/company/punishment/PunishmentFilters';
import { punishmentColumns } from '@/components/company/punishment/punishmentColumns';
import { punishmentFields } from '@/components/company/punishment/punishmentFields';
import CompanyHeader from '@/components/company/CompanyHeader';
import MainTable from '@/components/company/table/MainTable';

export default function Punishment() {
  const {
    isLoading,
    allPublished,
    filteredPunishments,
    formControl,
    formMode,
    setFormMode,
    formRef,
    handleSave,
    handleDelete,
    onEdit,
    reset,
    pageConfig,
    setPageConfig,
    bulkPublishPunishmentHandler,
    searchTerm,
    setSearchTerm,
    selectedRole,
    setSelectedRole,
    selectedStatus,
    setSelectedStatus,
    clearFilters,
    roleOptions,
  } = usePunishmentLogic();

  return (
    <section className="w-full">
      <CompanyHeader
        title="Punishment Systems"
        description="Manage your company's disciplinary actions and punishment policies."
        onCreate={() => {
          reset({ name: '', value: '', description: '' });
          setFormMode('add');
        }}
        onPublish={bulkPublishPunishmentHandler}
        isPublished={allPublished}
      />

      <div className="mx-5 border-b border-gray-200" />

      {formMode && (
        <PunishmentForm
          formControl={formControl}
          formRef={formRef}
          fields={punishmentFields(roleOptions)}
          formMode={formMode}
          handleSave={handleSave}
          reset={reset}
          setFormMode={setFormMode}
        />
      )}

      <PunishmentFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedRole={selectedRole}
        setSelectedRole={setSelectedRole}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        clearFilters={clearFilters}
        roleOptions={roleOptions}
      />

      <MainTable
        showHeader={false}
        isLoading={isLoading}
        data={{
          content: filteredPunishments as any[],
          totalElements: filteredPunishments.length,
          totalPages: 1,
        }}
        columns={punishmentColumns}
        pageConfig={pageConfig}
        setPageConfig={setPageConfig}
        onEdit={onEdit}
        onDelete={handleDelete}
        showActions
        useConfirmDelete
      />
    </section>
  );
}
